import './styles/animations.css';
import { MainLayout } from './components/Layout';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastProvider, ToastContainer } from './components/Toast';
import { NoScriptFallback } from './components/NoScript';
import PerformanceWrapper from './components/PerformanceWrapper';
import AdminPage from './pages/AdminPage';
import TestPage from './pages/TestPage';
// Import database setup for diagnostics
import './utils/setupDatabase.js';

function App() {
  // Simple routing based on URL path
  const currentPath = window.location.pathname;
  const isAdminRoute = currentPath === '/admin' || currentPath.startsWith('/admin/');
  const isTestRoute = currentPath === '/test';

  if (isAdminRoute) {
    return <AdminPage />;
  }

  if (isTestRoute) {
    return <TestPage />;
  }

  return (
    <ErrorBoundary>
      <PerformanceWrapper enableMonitoring={true} performanceThreshold={25}>
        <ToastProvider maxToasts={5}>
          <NoScriptFallback />
          <MainLayout />
          <ToastContainer position="top-right" />
        </ToastProvider>
      </PerformanceWrapper>
    </ErrorBoundary>
  );
}

export default App;